import { __assign } from "tslib";
var LoggerStatus;
(function (LoggerStatus) {
    LoggerStatus["debug"] = "debug";
    LoggerStatus["info"] = "info";
    LoggerStatus["warn"] = "warn";
    LoggerStatus["error"] = "error";
    LoggerStatus["critical"] = "critical";
})(LoggerStatus || (LoggerStatus = {}));
var Logger = (function () {
    function Logger() {
    }
    Logger.prototype.adapter = function (config) {
        if (config) {
            config();
        }
    };
    Logger.prototype.info = function (message, data) {
        this.log(message, data, LoggerStatus.info);
    };
    Logger.prototype.warn = function (message, data) {
        this.log(message, data, LoggerStatus.warn);
    };
    Logger.prototype.error = function (message, data) {
        this.log(message, data, LoggerStatus.error);
    };
    Logger.prototype.debug = function (message, data) {
        if (process.env.NODE_ENV !== 'production') {
            this.log(message, data, LoggerStatus.debug);
        }
    };
    Logger.prototype.critical = function (message, data) {
        this.log(message, data, LoggerStatus.critical);
    };
    Logger.prototype.setUserInfo = function (userInfo) {
        var _a, _b;
        var id = userInfo.id, name = userInfo.name, corpId = userInfo.corpId, corpIdName = userInfo.corpIdName;
        (_a = this === null || this === void 0 ? void 0 : this.logInstance) === null || _a === void 0 ? void 0 : _a.setUser({ id: id, name: name });
        (_b = this === null || this === void 0 ? void 0 : this.logInstance) === null || _b === void 0 ? void 0 : _b.setGlobalContext({ corpId: corpId, corpIdName: corpIdName });
    };
    Logger.prototype.log = function (message, data, status) {
        var _a, _b, _c;
        if (console[status]) {
            console[status](message, data);
        }
        else {
            console.log("\u3010" + status + "\u3011\uFF1A", message, data);
        }
        if (process.env.NODE_ENV === 'production') {
            (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.logInstance) === null || _a === void 0 ? void 0 : _a.logger) === null || _b === void 0 ? void 0 : _b[status]) === null || _c === void 0 ? void 0 : _c.call(_b, JSON.stringify(__assign({ log_name: message }, data)), { log_name: message });
        }
    };
    return Logger;
}());
export default Logger;
